<template>
    <div class="operate">
        <el-dialog :title="rowData.status == 1 ? '禁售' : '解封'" :visible.sync="dialogVisible" width="576px" :before-close="handleClose">
            <div class="content">
                <el-form ref="form" :model="form" label-width="120px">
                    <el-form-item>
                        <div class="box">
                            <div class="row">
                                <p>{{ rowData.status == 1 ? "禁止该经销商售卖" : "解封该经销商的售卖权" }}</p>
                                <el-radio v-model="form.type" label="1"></el-radio>
                            </div>
                            <span>{{ rowData.status == 1 ? "选择该选项之后，该经销商不能在网站售卖该商品" : "选择该选项之后，该经销商可以正常售卖该产品" }}</span>
                        </div>
                    </el-form-item>
                    <el-form-item>
                        <div class="box">
                            <div class="row">
                                <p>{{ rowData.status == 1 ? "禁止该产品售卖" : "解封该产品的售卖权" }}</p>
                                <el-radio v-model="form.type" label="2"></el-radio>
                            </div>
                            <span>{{ rowData.status == 1 ? "选择该选项之后，其他经销商同型号的产品将全部禁售" : "选择该选项之后，其他经销商可以正常售卖该产品" }}</span>
                        </div>
                    </el-form-item>
                    <el-form-item v-show="rowData.status == 1">
                        <el-input type="textarea" :rows="4" placeholder="请输入原因" v-model="form.reason"> </el-input>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button size="medium" @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" size="medium" @click="submit">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { mapActions, mapMutations, mapGetters } from "vuex";
export default {
    data() {
        return {
            dialogVisible: false,
            listData: [],
            form: {
                type: "",
                reason: "",
            },
            type: "",
            rowData: {},
        };
    },
    computed: {
        ...mapGetters(["getToken"]),
    },
    mounted() {},
    created() {},
    methods: {
        ...mapActions({
            reopened: "brand/reopened",
            forbidsale: "brand/forbidsale",
        }),
        dataBind(row) {
            this.rowData = row;
        },
        submit() {
            if (this.form.type == "") {
                return this.$message.warning("请先选择类型！");
            }
            let opt = {
                token: this.getToken,
                id: this.rowData.id, //产品经销商id
                type: this.form.type,
            };
            let url;
            if (this.rowData.status == 1) {
                opt.reason = this.form.reason; //禁售理由
                url = this.forbidsale;
            } else {
                url = this.reopened;
            }
            url(opt).then((res) => {
                // console.log(res);
                if (res.data.code == 1) {
                    this.$message.success("操作成功！");
                    this.handleClose();
                    this.$emit("init");
                } else {
                    this.$message.error(res.data.msg);
                }
            });
        },
        handleClose() {
            this.dialogVisible = false;
            this.$refs.form.resetFields();
            this.form = {
                type: "",
                reason: "",
            };
        },
    },
};
</script>

<style lang="scss" scoped>
.operate {
    .content {
        max-height: 500px;
        overflow-y: auto;
        &::-webkit-scrollbar-track-piece {
            background: #d3dce6;
        }

        &::-webkit-scrollbar {
            width: 6px;
        }

        &::-webkit-scrollbar-thumb {
            background: #99a9bf;
            border-radius: 20px;
        }
    }
    ::v-deep .el-form-item__content {
        margin-left: 0 !important;
    }
    .box {
        width: 80%;
        .row {
            display: flex;
            align-items: center;
            justify-content: space-between;
            p {
                font-size: 18px;
                color: #333;
            }
        }
        span {
            font-size: 14px;
            color: #999;
        }
    }
    ::v-deep .el-radio__label {
        display: none;
    }
}
</style>